export const tokenErrorMessages: string[] = [
    'The token has expired.',
    'The token has been revoked.',
    'A token must be passed.',
];
